/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_ReportedInputs */

const en_us2_gallery_reported = /** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report received. The team will take a look.`)
};

const pt_br2_gallery_reported = /** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denúncia recebida. A equipe vai olhar.`)
};

const pt_pt2_gallery_reported = /** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denúncia recebida. A equipe vai olhar.`)
};

/** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */
const es_419_gallery_reported = en_us2_gallery_reported;

/** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */
const fr_fr2_gallery_reported = en_us2_gallery_reported;

/** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */
const de_de2_gallery_reported = en_us2_gallery_reported;

/** @type {(inputs: Gallery_ReportedInputs) => LocalizedString} */
const it_it2_gallery_reported = en_us2_gallery_reported;

/**
* | output |
* | --- |
* | "Report received. The team will take a look." |
*
* @param {Gallery_ReportedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_reported = /** @type {((inputs?: Gallery_ReportedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_ReportedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_reported(inputs)
	if (locale === "es-419") return es_419_gallery_reported(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_reported(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_reported(inputs)
	if (locale === "de-DE") return de_de2_gallery_reported(inputs)
	if (locale === "it-IT") return it_it2_gallery_reported(inputs)
	return en_us2_gallery_reported(inputs)
});
export { gallery_reported as "gallery.reported" }